import { makeObservable, observable, runInAction } from 'mobx';
import { IDialog } from '../../types';

export default class DialogStore {
    dialog: IDialog<any> = {};

    constructor() {
        makeObservable(this, {
            dialog: observable
        });
    }

    openDialog<T = boolean>({ title, message, okButton, isCustomTitle }: IDialog<T>): Promise<T | undefined> {
        return new Promise((resolve) => {
            this.dialog = {
                title,
                message,
                isOpen: true,
                cb: (res?: T) => {
                    res ? resolve(res) : {};
                    runInAction(() => {
                        this.dialog = {};
                    });
                },
                okButton: okButton ?? 'OK',
                isCustomTitle: isCustomTitle ?? false
            } as IDialog<T>;
        });
    }
}
